/** 用户
state: [{
    jid: String,
    email: String
    nick_name: String
    pinyin_name: String
    description: String
    created_at: Date
    avatar: String,
    status: String, default `offline`
}]
*/
import _ from 'underscore';
import { createAction, createReducer } from 'redux-act';

const initialState = [];

function _mapItem(obj) {
    return obj;
}

function _addOrEdit(state, obj) {
    let item = _.find(state, { jid: obj.jid });
    obj = _mapItem(obj);
    if (item) {
        _.extend(item, obj);
    } else {
        state.push(obj);
    }
}

export const add = createAction('add');
export const edit = createAction('edit');
export const addOrEdit = createAction('addOrEdit');

export default createReducer({
    [add]: (state, obj) => {
        let arr;
        if (_.isArray(obj)) {
            arr = _.map(obj, (item) => {
                return _mapItem(item);
            });
        } else {
            arr = [_mapItem(obj)];
        }

        return [
            ...arr,
            ...state
        ];
    },

    [edit]: (state, obj) => state.map(item => {
        return item.jid === obj.jid ? _.extend(item, _mapItem(obj)) : item;
    }),

    [addOrEdit]: (state, obj) => {
        if (_.isArray(obj)) {
            _.each(obj, (item) => {
                _addOrEdit(state, item);
            });
        } else {
            obj && _addOrEdit(state, obj);
        }
        return [...state];
    }
}, initialState);


// WEBPACK FOOTER //
// ./src/user/redux/index.js